import { FlightsShoppingPwaFlightInformationResults } from '__generated__/api';
import ChangeCancellationMessages = FlightsShoppingPwaFlightInformationResults.ChangeCancellationMessages;
import * as React from 'react';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { Phrase } from 'components/shared';

export const ChangeCancellationMessages = (changeCancellationMessages: ChangeCancellationMessages) => {
  const { heading, messages } = changeCancellationMessages;

  return (
    <div data-test-id="change-cancel">
      <UitkHeading level={3} size={300}>
        {heading}
      </UitkHeading>
      {messages && (
        <div className="all-t-margin-three" data-test-id="change-cancel-info">
          {messages.map((message, index) => (
            <UitkText key={index} size={200} spacing="three">
              <Phrase {...message} />
            </UitkText>
          ))}
        </div>
      )}
    </div>
  );
};
